(() => {
  const compact = text => text.replace(/\s/g, '');
  function prepare(root) {
    if (root.dataset.prepared) return;
    const source = root.querySelector('[data-baranbo-description]');
    if (!source) return;
    let text = '';
    const locations = [];
    function walk(node) {
      if (node.nodeType === 3) {
        const start = text.length;
        text += node.data;
        for (let i = 0; i < node.data.length; i++) locations[start + i] = [node, i];
      } else if (node.nodeType === 1) {
        const block = /^(P|DIV|LI|H[1-6]|TR|BR)$/.test(node.tagName);
        if (block && text && !text.endsWith('\n')) text += '\n';
        for (const child of node.childNodes) walk(child);
        if (block && !text.endsWith('\n')) text += '\n';
      }
    }
    walk(source);
    const pattern = /(?:^|\n)[ \t]*(Samenstelling|Ingrediënten|Ingredienten|Analytische bestanddelen|Voedingsadvies|Voedingsaanbeveling|Voedingsrichtlijnen?|Dosering|Gebruiksaanwijzing|Nutritionele toevoegingsmiddelen|Toevoegingsmiddelen|Inhoud|Afmetingen|Afmeting|Formaat|Kleur)(?=\s*(?:[:\n]|$|\(per))/gi;
    const markers = [];
    for (const match of text.matchAll(pattern)) {
      const index = match.index + match[0].indexOf(match[1]);
      if (!locations[index]) continue;
      const label = match[1].toLowerCase();
      const key = /samenstelling|ingred/.test(label) ? 'ingredients' : /analytische/.test(label) ? 'analysis' : /voedings/.test(label) ? 'feeding' : /toevoegings/.test(label) ? 'additives' : /dosering|gebruiks/.test(label) ? 'usage' : 'details';
      markers.push({ index, key });
    }
    const boundaries = [{ index: 0, key: 'description', first: true }, ...markers];
    const fragments = [];
    for (let i = 0; i < boundaries.length; i++) {
      const range = document.createRange();
      if (boundaries[i].first) range.setStart(source, 0);
      else range.setStart(...locations[boundaries[i].index]);
      if (i + 1 < boundaries.length) range.setEnd(...locations[boundaries[i + 1].index]);
      else range.setEnd(source, source.childNodes.length);
      fragments.push({ key: boundaries[i].key, fragment: range.cloneContents() });
    }
    if (compact(fragments.map(item => item.fragment.textContent).join('')) !== compact(source.textContent)) return;
    const container = document.createElement('div');
    const groups = new Map();
    for (const item of fragments) {
      if (!item.fragment.textContent.trim() && !item.fragment.querySelector('img,table,video')) continue;
      let content = groups.get(item.key);
      if (!content) {
        const details = document.createElement('details');
        details.open = item.key === 'description';
        const summary = document.createElement('summary');
        summary.textContent = root.dataset[item.key + 'Label'];
        content = document.createElement('div');
        content.className = 'baranbo-information-content rich-editor-text-content';
        details.append(summary, content);
        container.append(details);
        groups.set(item.key, content);
      }
      content.append(item.fragment);
    }
    const descriptionEnd = markers.length ? markers[0].index : text.length;
    const features = text.slice(0, descriptionEnd).split('\n').map(line => line.trim()).filter(line => /^[-•–]\s+\S/.test(line)).map(line => line.replace(/^[-•–]\s+/, '')).slice(0, 4);
    const highlights = root.closest('product-info')?.querySelector('[data-baranbo-highlights]');
    if (features.length && highlights) {
      const list = highlights.querySelector('ul');
      for (const feature of features) {
        const li = document.createElement('li');
        li.textContent = feature;
        list.append(li);
      }
      highlights.hidden = false;
    }
    root.dataset.prepared = 'true';
    root.querySelector('[data-information-sections]').replaceChildren(...container.childNodes);
  }
  function initialize(scope = document) {
    for (const root of scope.querySelectorAll('[data-baranbo-information]')) {
      try { prepare(root); } catch (error) { console.warn('Baranbo: original product information retained.', error); }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
